module.exports = __webpack_public_path__ + "img/5.36b68701.svg";